import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  signal,
  inject,
} from '@angular/core';
import { FilePondOptions } from 'filepond';
import { FilePondComponent } from 'ngx-filepond';
import { BankAccount } from '../../../shared/core/state/earnings/bank-account.model';
import { FilePondConfigService } from '../../../shared/services/filepond-config.service';

@Component({
  selector: 'black-bank-account-form',
  templateUrl: './bank-account-form.component.html',
  styleUrls: ['./bank-account-form.component.css'],
  standalone: false,
})
export class BankAccountFormComponent implements OnInit {
  private filePondConfig = inject(FilePondConfigService);

  @Input() currentAccount: BankAccount | null = null;
  @Output() saved = new EventEmitter<Omit<BankAccount, '_id' | 'user'>>();
  @Output() cancelled = new EventEmitter<void>();

  @ViewChild('bankBookPond') bankBookPond!: FilePondComponent;

  accountHolderName = signal('');
  bankName = signal('');
  branchName = signal('');
  accountNumber = signal('');
  bankBookResourceId = signal<string | null>(null);
  formError = signal<string | null>(null);

  pondFiles: FilePondOptions['files'] = [];

  pondOptions: FilePondOptions = {
    allowMultiple: false,
    labelIdle: 'Upload bank book front page (optional) — <span class="filepond--label-action">Browse</span>',
    acceptedFileTypes: ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf'],
    allowFileTypeValidation: true,
    labelFileTypeNotAllowed: 'Only images (PNG/JPEG) or PDF are accepted',
  };

  async ngOnInit(): Promise<void> {
    const server = await this.filePondConfig.getServerConfig({
      load: true,
      allowRevert: true,
    });
    this.pondOptions = { ...this.pondOptions, server };

    if (this.currentAccount) {
      this.accountHolderName.set(this.currentAccount.accountHolderName ?? '');
      this.bankName.set(this.currentAccount.bankName ?? '');
      this.branchName.set(this.currentAccount.branchName ?? '');
      this.accountNumber.set(this.currentAccount.accountNumber ?? '');

      const bankBook = this.currentAccount.bankBookResource;
      if (bankBook) {
        const resourceId = typeof bankBook === 'string' ? bankBook : bankBook._id;
        this.bankBookResourceId.set(resourceId);
        this.pondFiles = [
          {
            source: resourceId,
            options: { type: 'local' },
          },
        ];
      }
    }
  }

  pondHandleProcessFile(event: any): void {
    const resourceId = event?.file?.serverId;
    if (resourceId) {
      this.bankBookResourceId.set(resourceId);
    }
  }

  pondHandleRemoveFile(): void {
    this.bankBookResourceId.set(null);
  }

  submit(): void {
    if (
      !this.accountHolderName() ||
      !this.bankName() ||
      !this.branchName() ||
      !this.accountNumber()
    ) {
      this.formError.set('All fields are required');
      return;
    }

    this.formError.set(null);
    this.saved.emit({
      accountHolderName: this.accountHolderName(),
      bankName: this.bankName(),
      branchName: this.branchName(),
      accountNumber: this.accountNumber(),
      bankBookResource: this.bankBookResourceId() ?? undefined,
    });
  }

  cancel(): void {
    this.cancelled.emit();
  }
}
